import { Box, Button, Typography } from "@mui/material";
import ExampleImage from "../../../src/assets/success-cases-example.jpg";
import BackgroundShapes from "../../../src/assets/background_shapes.png";
import "./InfoSuccessCases.scss";
import { ChevronLeft, Heart } from "lucide-react";
import { useContext, useEffect, useState } from "react";
import { SuccessCasesContext } from "../SuccessCases/SuccessCases";
import ideasServices from "../../services/ideasServices";

export default function InfoSuccessCases(props: { idea: any }) {
  const { setOpenIdea, upvote, deleteVote } = useContext(SuccessCasesContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isVoted, setIsVoted] = useState(false);

  const fetchData = async () => {
    await ideasServices
      .verifyVote(props.idea.idea_id)
      .then((res) => setIsVoted(res));
  };

  useEffect(() => {
    const voteStatus = async () => {
      setIsLoading(true);
      await fetchData();
      setIsLoading(false);
    };

    voteStatus();
  }, [props.idea.idea_id]);

  const handleVote = async (idea: any) => {
    setIsLoading(true);
    if (isVoted) {
      await deleteVote(idea);
      setIsVoted(false);
    } else {
      await upvote(idea);
      setIsVoted(true);
    }
    await new Promise((res) => setTimeout(res, 1000));
    setIsLoading(false);
  };

  return (
    <>
      <Box className="info">
        <Box className="info__background-image">
          <img src={props.idea.image_url ?? ExampleImage} alt="" />
        </Box>
        <Box className="info__background-shape">
          <img src={BackgroundShapes} alt="" />
        </Box>
        <Box className="info__container">
          <Box className="info__container__header">
            <Box>
              <Typography className="info__container__header-title">
                {props.idea.title}
              </Typography>
            </Box>
            <Box className="info__container__header__like">
              <Box className="info__container__header__like__texts">
                {isVoted && (
                  <>
                    <Typography className="info__container__header__like__texts-title">
                      ¡Ya votaste por esta idea!
                    </Typography>
                    <Typography className="info__container__header__like__texts-subtitle">
                      Oprime para eliminar tu voto
                    </Typography>
                  </>
                )}
                {!isVoted && (
                  <>
                    <Typography className="info__container__header__like__texts-title">
                      ¿Te agrada esta idea?
                    </Typography>
                    <Typography className="info__container__header__like__texts-subtitle">
                      ¡Dale "Me gusta"!
                    </Typography>
                  </>
                )}
              </Box>
              <Box
                onClick={() => handleVote(props.idea.idea_id)}
                className="info__container__header__like-icon"
              >
                <Heart fill={isVoted ? "white" : "#671e75"} />
              </Box>
            </Box>
          </Box>
          <Box className="info__container__hospital-unit">
            <Typography className="info__container-label">Unidad:</Typography>
            <Typography className="info__container-name">
              {props.idea.hospital_area}
            </Typography>
          </Box>
          <Box className="info__container__authors">
            <Typography className="info__container-label">
              Autor(es):
            </Typography>
            <Typography className="info__container-name">
              {props.idea.authors
                .map(
                  (author: any) => `${author.first_name} ${author.last_name}`
                )
                .join(", ")}
            </Typography>
          </Box>
          <Typography className="info__container-description">
            {props.idea.description}
          </Typography>
        </Box>
        <Button onClick={() => setOpenIdea(false)} className="info-back-button">
          <ChevronLeft />
          <Typography>Regresar</Typography>
        </Button>
      </Box>
      {isLoading && (
        <Box className="loader-overlay">
          <Box className="loader-container">
            <Box className="custom-loader" />
          </Box>
        </Box>
      )}
    </>
  );
}
